module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"add":"Add сard","renewSubscriptionAfterCreating":"Renew my subscription once I have added a payment method"}}')
  delete Component.options._Ctor
}
